import { ButtonProps } from "@chakra-ui/react";

import { ExportButton } from "@/common/components/ExportButton";
import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { API_URL } from "@/common/utils/env";
import { useFlag } from "@reflag/react-sdk";
import { UsersBody } from "@reflag/shared/userAPI";

interface ExportUsersButtonProps extends Omit<ButtonProps, "onClick"> {
  exportParams: Omit<UsersBody, "pageIndex" | "pageSize">;
}

export function ExportUsersButton({ exportParams }: ExportUsersButtonProps) {
  const { appId, envId } = useEnvironment();
  const { isEnabled: csvExportEnabled } = useFlag("csv-export");

  // Don't render the button if the feature flag is disabled
  if (!csvExportEnabled) {
    return null;
  }

  const formFields = {
    idNameEmailFilter: exportParams.idNameEmailFilter,
    filter: exportParams.filter,
    companyId: exportParams.companyId,
    sortBy: exportParams.sortBy,
    sortOrder: exportParams.sortOrder,
    columns: exportParams.columns,
  };

  const exportUrl = `${API_URL}/apps/${appId}/users/export?envId=${envId}`;

  return <ExportButton exportUrl={exportUrl} formFields={formFields} />;
}
